import validator from 'validator'
import { CNPJValidator } from './cnpj-validator';

/**
 * @param {string} input
 * @returns {boolean}
 */
const isValidCNPJ = (input) => {
    if (typeof input !== 'string') return false;

    const cnpj = input.replace(/[^A-Z0-9]/g,'');
 
    if (cnpj === '') return false;
     
    if (cnpj.length !== 14)
        return false

    return CNPJValidator.isValid(cnpj);
}

const isValidCPF = (strCPF) => {
    let Soma = 0
    let Resto
    strCPF = strCPF.replace(/[^0-9]/g,'')
    if (strCPF === "00000000000") return false
     
    for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i)
    Resto = (Soma * 10) % 11
   
    if ((Resto === 10) || (Resto === 11))  Resto = 0
    if (Resto !== parseInt(strCPF.substring(9, 10)) ) return false
   
    Soma = 0
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i)
    Resto = (Soma * 10) % 11
   
    if ((Resto === 10) || (Resto === 11))  Resto = 0
    if (Resto !== parseInt(strCPF.substring(10, 11) ) ) return false
    return true
}

export const requiredField = (val) => (!val || !val?.length) ? 'Este campo é obrigatório' : null;
export const objectField = (val) => (!val) ? 'Este campo é obrigatório' : null;
export const emailField = (val) => (!val || !validator.isEmail(val)) ? 'Digite um e-mail válido' : null;
export const phoneField = (val) => (!val || !/[0-9]{10,11}/.test(val.replace(/[^0-9]/g, ''))) ? 'Digite um telefone válido' : null;
export const cnpjField = (val) => (!val || !isValidCNPJ(val)) ? 'Digite um CNPJ válido' : null;
export const cpfField = (val) => (!val || !isValidCPF(val)) ? 'Digite um CPF válido' : null;
export const cepField = (val) => (!val || !/^[0-9]{5}[-]{0,1}[0-9]{3}$/.test(val)) ? 'Digite um CEP válido' : null;
export const dateField = (val) => (!val || typeof val !== "object") ? 'Digite/Selecione uma Data válida' : null;

/* Opcionais */
export const optionalEmailField = (val) => (val !== '' && !validator.isEmail(val)) ? 'Digite um e-mail válido' : null;
export const optionalPhoneField = (val) => (val !== '' && !/(\(?\d{2}\)?) ?9?\d{4}-?\d{4}/.test(val)) ? 'Digite um telefone válido' : null;
export const optionalDateField = (val) => (val !== '' && typeof val !== "object") ? 'Digite/Selecione uma Data válida' : null;
